import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import moment from "moment/moment";
import { Calendar as PCalendar } from 'primereact/calendar';

const PayrollFormComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    date_from: null,
    date_until: null
  });
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    if (!formData.date_from || !formData.date_until) errors.range = 'Válaszd ki a teljes időszakot.';
    else if (formData.date_from > formData.date_until) errors.range = 'A záródátum nem előzheti meg a kezdődátumot.';
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
          date_from: formData?.date_from,
          date_until: formData?.date_until
        };
    // if ((window.App.urlVars().payrollId) || (entity === 'checkin' && id)) {
    //   apiCall('patch', '/api/v2/export/checkin/' + (window.App.urlVars().payrollId ?? id), newFormData)
    //     .then(response => {
    //       window.App.toastShow('success', t('toastSaveSuccess'));
    //       window.App.setState({rerenderPayrollList: Math.random()})
    //       if (props.goback === true) {
    //         history.push(props.backlink);
    //       }
    //     })
    //     .catch(error => {
    //       window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //     })
    //     .finally(() => {
    //       setLoading(false);
    //     })
    // } 
    // else {

      apiCall('post', '/api/v2/export/checkin', payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderCheckinexportList: Math.random()})
          // if (props.goback === true) {
          //   history.push(props.backlink);
          // } else {
          //   history.push('/hr/checkin/update/' + response.data.data.id);
          // }
          // setFormData({ date_from: null, date_until: null, range: null });
          form.restart(); 
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    // }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }
  
  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().payrollId) || (entity === 'checkin' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/expert/checkin/' + (window.App.urlVars().payrollId ?? id))
        .then(response => {
          // setFormData(response.data.data)
					let range = null;
					if (response.data.data.date_from && response.data.data.date_until) {
						const s = moment(response.data.data.date_from);
						const e = moment(response.data.data.date_until);
						range = [s.toDate(), e.toDate()];
					}
					setFormData(prev=> ({
						...prev,
						...response.data.data,
						range: range,
					}));
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"tmp-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="range" render={({meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="range"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRange')}</label>
                  <span className="p-d-block">
                    <PCalendar
                      id="range"
                      selectionMode="range"
                      locale="hu"
                      dateFormat="yy-mm-dd"
                      value={formData.range}
                      onChange={(e) => {
                        const val = e.value;
                        if (Array.isArray(val) && val[0] && val[1]) {
                          const from = moment(val[0]).format('YYYY-MM-DD');
                          const until = moment(val[1]).format('YYYY-MM-DD');
                          setFormData({
                            ...formData,
                            range: val,
                            date_from: from,
                            date_until: until
                          });
                          setNewFormData({
                            ...newFormData,
                            date_from: from,
                            date_until: until
                          });
                        } else {
                          setFormData({
                            ...formData,
                            range: val,
                            date_from: null,
                            date_until: null
                          });
                        }
                      }}
                      readOnlyInput
                      showIcon
                      disabled={formData.closed}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-3 p-xl-3"}>

            </div>
            <div className={"p-col-12 p-lg-9 p-xl-9 p-text-right p-col-align-center"}>


							{/* {entity === 'checkin' && ((!!window.App.urlVars().payrollId) || (entity === 'checkin' && !!id)) && !formData.closed &&
                <Button type="button" label="Lezárás"
                        loading={closing}
                        icon={"pi pi-lock"}
                        onClick={handleClosePayroll}
                        className="p-button-warning p-ml-2"/>
              } */}


              {entity === 'checkin' &&
                <Button type="submit" label={t('startExport')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              {/* <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/> */}
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PayrollFormComponent);
